var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconAccountingInvoiceHand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71 8.84a2.22 2.22 0 0 0 1.86.88c1.14 0 2.06-.69 2.06-1.55s-.92-1.54-2.06-1.54-2.07-.7-2.07-1.55.93-1.55 2.07-1.55a2.22 2.22 0 0 1 1.86.88M8.57 9.72v1.03m0-8.25v1.03M23.25 21l-1.5-2.24V13.5c0-2-3.8-4.14-5.25-5.25m1.93 6.54-3.64-2.92a1.3 1.3 0 1 0-1.85 1.84l3.54 4v2.5c0 1.18 1.68 3 1.68 3",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.25V2.12A1.37 1.37 0 0 0 15.13.75H11.5m2 22.5H2.13a1.38 1.38 0 0 1-1.38-1.37V2.12A1.38 1.38 0 0 1 2.13.75H5.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.25H4.5a.76.76 0 0 0-.75.75v5.5a.76.76 0 0 0 .75.75h9m-9.75-3.5h7.75m-3.25-3.5v7",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconAccountingInvoiceHand);
export default __webpack_public_path__ + "static/media/streamline-icon-accounting-invoice-hand.1b7fe3d2.svg";
export { ForwardRef as ReactComponent };